import styled from "styled-components";

export const SliderContainer = styled.div`
  margin-top: 32px;
  position: relative;
  @media only screen and (min-width: 768px) {
    width: calc(100% + 96px);
    height: 20px;
    display: flex;
    justify-content: start;
  }
`;
